<tt-page class="col-xs-12 col-md-4 sp-0">
    <tt-card>
        <tt-button-goto ttText="new" ttGoto="textilemodelcategory3" [ttGotoParms]="{ textilemodelcategory3_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list [ttData]="itemsListCategories3"></tt-list>
</tt-page>
